import { Link } from "react-router-dom";
import { CircleSlash } from "lucide-react";
import { useI18n } from "@/i18n";
import { PAY } from "@/i18n/pay";

export default function PaymentCancel() {
  const { lang } = useI18n();
  const p = PAY[lang] || PAY.fr;
  return (
    <div className="mx-auto max-w-xl px-5 py-28 text-center" data-testid="payment-cancel-page">
      <CircleSlash className="mx-auto text-brass" size={44} />
      <h1 className="mt-6 font-display text-4xl text-bone">{p.cancelTitle}</h1>
      <p className="mt-4 text-sm text-muted-foreground">{p.cancelNote}</p>
      <div className="mt-9 flex justify-center gap-4">
        <Link to="/reservation" className="btn-primary" data-testid="cancel-retry-btn">{p.backCal}</Link>
        <Link to="/" className="btn-ghost">{p.homeShort}</Link>
      </div>
    </div>
  );
}
